import React, { FC, useState } from 'react';
import { ButtonBase, IconButton, Paper, Popover, Typography } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MdFilterList as FilterIcon } from '@react-icons/all-files/md/MdFilterList';
import { MdArrowForward as ArrowIcon } from '@react-icons/all-files/md/MdArrowForward';
import { FaSortAmountUp as SortUpIcon } from '@react-icons/all-files/fa/FaSortAmountUp';
import { FaSortAmountDown as SortDownIcon } from '@react-icons/all-files/fa/FaSortAmountDown';
import { createUseStyles } from '../../../../../../../theming';
import MomentUtils from '@date-io/moment';
import moment, { Moment } from 'moment';
import Button from '../../../../../../../components/Button';
import { Order } from '../../../../../../../interfaces/Table';

const useStyles = createUseStyles({
  button: {
    border: '1px solid #00000036 !important',
    borderRadius: '4px !important',
    background: 'white !important',
    padding: '10px !important',
  },
  subtitle: {
    marginBottom: 5,
  },
  dateRangeContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  menu: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  datePicker: {
    maxWidth: 150,
  },
});

interface Props {
  onChange: (startDate: string | null, endDate: string | null, order: Order) => void;
  startDate: string | null;
  endDate: string | null;
  order: Order;
}

const DateFilter: FC<Props> = ({ startDate, endDate, order, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClearDateFilter = () => {
    onChange(null, null, order);
  };

  const formatDate = (date: Moment | null) => (date ? date.format('YYYY-MM-DD') : null);
  const momentDate = (date: string | null) => (date ? moment(date, 'YYYY-MM-DD') : null);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ButtonBase className={classes.button} onClick={handleOpenMenu}>
        <FilterIcon size={18} />
      </ButtonBase>

      <Popover anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
        <Paper className={classes.menu}>
          <div className={classes.header}>
            <Typography variant='subtitle2' className={classes.subtitle}>
              Filtrer par dates
            </Typography>

            <Button variant='text' size='small' color='primary' onClick={handleClearDateFilter}>
              Effacer
            </Button>
          </div>

          <div className={classes.dateRangeContainer}>
            <DatePicker
              className={classes.datePicker}
              label='Date de début'
              format='DD/MM/YYYY'
              value={momentDate(startDate)}
              onChange={(date) => onChange(formatDate(date), endDate, order)}
            />

            <ArrowIcon size={16} style={{ margin: '10px 5px 0 5px' }} />

            <DatePicker
              className={classes.datePicker}
              label='Date de fin'
              format='DD/MM/YYYY'
              value={momentDate(endDate)}
              onChange={(date) => onChange(startDate, formatDate(date), order)}
            />

            <IconButton
              style={{ marginTop: 10 }}
              onClick={() => onChange(startDate, endDate, order === 'asc' ? 'desc' : 'asc')}
            >
              {order === 'asc' ? <SortDownIcon size={18} /> : <SortUpIcon size={18} />}
            </IconButton>
          </div>
        </Paper>
      </Popover>
    </MuiPickersUtilsProvider>
  );
};

export default DateFilter;
